@file:OptIn(InternalResourceApi::class)

package fr.frux.feature.auth.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/fr.frux.feature.auth.resources/"

@delegate:ResourceContentHash(1_522_803_955)
internal val Res.string.auth_browse_anonymously: StringResource by lazy {
      StringResource("string:auth_browse_anonymously", "auth_browse_anonymously", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 59),
      ))
    }

@delegate:ResourceContentHash(1_838_797_045)
internal val Res.string.auth_change_email: StringResource by lazy {
      StringResource("string:auth_change_email", "auth_change_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70, 49),
      ))
    }

@delegate:ResourceContentHash(-1_702_300_502)
internal val Res.string.auth_code_label: StringResource by lazy {
      StringResource("string:auth_code_label", "auth_code_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120, 31),
      ))
    }

@delegate:ResourceContentHash(699_029_632)
internal val Res.string.auth_code_not_received: StringResource by lazy {
      StringResource("string:auth_code_not_received", "auth_code_not_received", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152, 54),
      ))
    }

@delegate:ResourceContentHash(-1_120_297_004)
internal val Res.string.auth_code_placeholder: StringResource by lazy {
      StringResource("string:auth_code_placeholder", "auth_code_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207, 45),
      ))
    }

@delegate:ResourceContentHash(305_472_755)
internal val Res.string.auth_code_resent: StringResource by lazy {
      StringResource("string:auth_code_resent", "auth_code_resent", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 253, 64),
      ))
    }

@delegate:ResourceContentHash(-419_499_132)
internal val Res.string.auth_code_sent: StringResource by lazy {
      StringResource("string:auth_code_sent", "auth_code_sent", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 318, 50),
      ))
    }

@delegate:ResourceContentHash(1_513_740_406)
internal val Res.string.auth_create_account: StringResource by lazy {
      StringResource("string:auth_create_account", "auth_create_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 369, 51),
      ))
    }

@delegate:ResourceContentHash(-1_713_180_008)
internal val Res.string.auth_email_label: StringResource by lazy {
      StringResource("string:auth_email_label", "auth_email_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 421, 32),
      ))
    }

@delegate:ResourceContentHash(908_461_598)
internal val Res.string.auth_email_placeholder: StringResource by lazy {
      StringResource("string:auth_email_placeholder", "auth_email_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 454, 50),
      ))
    }

@delegate:ResourceContentHash(231_200_118)
internal val Res.string.auth_error_app_outdated: StringResource by lazy {
      StringResource("string:auth_error_app_outdated", "auth_error_app_outdated", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 505, 135),
      ))
    }

@delegate:ResourceContentHash(1_412_082_876)
internal val Res.string.auth_error_code_invalid_format: StringResource by lazy {
      StringResource("string:auth_error_code_invalid_format", "auth_error_code_invalid_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 641, 90),
      ))
    }

@delegate:ResourceContentHash(1_173_867_291)
internal val Res.string.auth_error_code_invalid_or_expired: StringResource by lazy {
      StringResource("string:auth_error_code_invalid_or_expired", "auth_error_code_invalid_or_expired", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 732, 102),
      ))
    }

@delegate:ResourceContentHash(-172_309_447)
internal val Res.string.auth_error_code_required: StringResource by lazy {
      StringResource("string:auth_error_code_required", "auth_error_code_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 835, 76),
      ))
    }

@delegate:ResourceContentHash(-1_823_339_185)
internal val Res.string.auth_error_email_invalid: StringResource by lazy {
      StringResource("string:auth_error_email_invalid", "auth_error_email_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 912, 84),
      ))
    }

@delegate:ResourceContentHash(-1_542_810_695)
internal val Res.string.auth_error_email_required: StringResource by lazy {
      StringResource("string:auth_error_email_required", "auth_error_email_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 997, 73),
      ))
    }

@delegate:ResourceContentHash(574_311_599)
internal val Res.string.auth_error_email_too_long: StringResource by lazy {
      StringResource("string:auth_error_email_too_long", "auth_error_email_too_long", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1071, 81),
      ))
    }

@delegate:ResourceContentHash(-280_172_714)
internal val Res.string.auth_error_username_invalid: StringResource by lazy {
      StringResource("string:auth_error_username_invalid", "auth_error_username_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1153, 219),
      ))
    }

@delegate:ResourceContentHash(-2_069_213_652)
internal val Res.string.auth_error_username_required: StringResource by lazy {
      StringResource("string:auth_error_username_required", "auth_error_username_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1373, 76),
      ))
    }

@delegate:ResourceContentHash(-2_120_019_685)
internal val Res.string.auth_error_username_reserved: StringResource by lazy {
      StringResource("string:auth_error_username_reserved", "auth_error_username_reserved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1450, 112),
      ))
    }

@delegate:ResourceContentHash(-1_344_887_930)
internal val Res.string.auth_error_username_taken: StringResource by lazy {
      StringResource("string:auth_error_username_taken", "auth_error_username_taken", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1563, 85),
      ))
    }

@delegate:ResourceContentHash(-1_480_839_986)
internal val Res.string.auth_error_username_too_long: StringResource by lazy {
      StringResource("string:auth_error_username_too_long", "auth_error_username_too_long", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1649, 112),
      ))
    }

@delegate:ResourceContentHash(532_576_992)
internal val Res.string.auth_error_username_too_short: StringResource by lazy {
      StringResource("string:auth_error_username_too_short", "auth_error_username_too_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1762, 117),
      ))
    }

@delegate:ResourceContentHash(-168_573_246)
internal val Res.string.auth_legal_notice: StringResource by lazy {
      StringResource("string:auth_legal_notice", "auth_legal_notice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1880, 89),
      ))
    }

@delegate:ResourceContentHash(1_194_462_461)
internal val Res.string.auth_legal_privacy: StringResource by lazy {
      StringResource("string:auth_legal_privacy", "auth_legal_privacy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1970, 70),
      ))
    }

@delegate:ResourceContentHash(534_797_460)
internal val Res.string.auth_legal_terms: StringResource by lazy {
      StringResource("string:auth_legal_terms", "auth_legal_terms", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2041, 60),
      ))
    }

@delegate:ResourceContentHash(-1_071_035_510)
internal val Res.string.auth_open_about: StringResource by lazy {
      StringResource("string:auth_open_about", "auth_open_about", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2102, 71),
      ))
    }

@delegate:ResourceContentHash(-1_933_778_749)
internal val Res.string.auth_request_code: StringResource by lazy {
      StringResource("string:auth_request_code", "auth_request_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2174, 49),
      ))
    }

@delegate:ResourceContentHash(95_370_368)
internal val Res.string.auth_resend_code: StringResource by lazy {
      StringResource("string:auth_resend_code", "auth_resend_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2294, 48),
      ))
    }

@delegate:ResourceContentHash(2_024_650_919)
internal val Res.string.auth_resend_code_cooldown: StringResource by lazy {
      StringResource("string:auth_resend_code_cooldown", "auth_resend_code_cooldown", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2224, 69),
      ))
    }

@delegate:ResourceContentHash(-935_517_739)
internal val Res.string.auth_session_expired: StringResource by lazy {
      StringResource("string:auth_session_expired", "auth_session_expired", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2343, 72),
      ))
    }

@delegate:ResourceContentHash(-1_334_432_693)
internal val Res.string.auth_title_code: StringResource by lazy {
      StringResource("string:auth_title_code", "auth_title_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2416, 47),
      ))
    }

@delegate:ResourceContentHash(1_027_661_682)
internal val Res.string.auth_title_email: StringResource by lazy {
      StringResource("string:auth_title_email", "auth_title_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2464, 48),
      ))
    }

@delegate:ResourceContentHash(-656_803_399)
internal val Res.string.auth_title_username: StringResource by lazy {
      StringResource("string:auth_title_username", "auth_title_username", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2513, 55),
      ))
    }

@delegate:ResourceContentHash(-964_917_856)
internal val Res.string.auth_username_intro: StringResource by lazy {
      StringResource("string:auth_username_intro", "auth_username_intro", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2569, 95),
      ))
    }

@delegate:ResourceContentHash(1_770_736_021)
internal val Res.string.auth_username_label: StringResource by lazy {
      StringResource("string:auth_username_label", "auth_username_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2665, 51),
      ))
    }

@delegate:ResourceContentHash(-1_061_417_321)
internal val Res.string.auth_username_placeholder: StringResource by lazy {
      StringResource("string:auth_username_placeholder", "auth_username_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2717, 49),
      ))
    }

@delegate:ResourceContentHash(467_853_974)
internal val Res.string.auth_validate_code: StringResource by lazy {
      StringResource("string:auth_validate_code", "auth_validate_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2767, 46),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("auth_browse_anonymously", Res.string.auth_browse_anonymously)
  map.put("auth_change_email", Res.string.auth_change_email)
  map.put("auth_code_label", Res.string.auth_code_label)
  map.put("auth_code_not_received", Res.string.auth_code_not_received)
  map.put("auth_code_placeholder", Res.string.auth_code_placeholder)
  map.put("auth_code_resent", Res.string.auth_code_resent)
  map.put("auth_code_sent", Res.string.auth_code_sent)
  map.put("auth_create_account", Res.string.auth_create_account)
  map.put("auth_email_label", Res.string.auth_email_label)
  map.put("auth_email_placeholder", Res.string.auth_email_placeholder)
  map.put("auth_error_app_outdated", Res.string.auth_error_app_outdated)
  map.put("auth_error_code_invalid_format", Res.string.auth_error_code_invalid_format)
  map.put("auth_error_code_invalid_or_expired", Res.string.auth_error_code_invalid_or_expired)
  map.put("auth_error_code_required", Res.string.auth_error_code_required)
  map.put("auth_error_email_invalid", Res.string.auth_error_email_invalid)
  map.put("auth_error_email_required", Res.string.auth_error_email_required)
  map.put("auth_error_email_too_long", Res.string.auth_error_email_too_long)
  map.put("auth_error_username_invalid", Res.string.auth_error_username_invalid)
  map.put("auth_error_username_required", Res.string.auth_error_username_required)
  map.put("auth_error_username_reserved", Res.string.auth_error_username_reserved)
  map.put("auth_error_username_taken", Res.string.auth_error_username_taken)
  map.put("auth_error_username_too_long", Res.string.auth_error_username_too_long)
  map.put("auth_error_username_too_short", Res.string.auth_error_username_too_short)
  map.put("auth_legal_notice", Res.string.auth_legal_notice)
  map.put("auth_legal_privacy", Res.string.auth_legal_privacy)
  map.put("auth_legal_terms", Res.string.auth_legal_terms)
  map.put("auth_open_about", Res.string.auth_open_about)
  map.put("auth_request_code", Res.string.auth_request_code)
  map.put("auth_resend_code", Res.string.auth_resend_code)
  map.put("auth_resend_code_cooldown", Res.string.auth_resend_code_cooldown)
  map.put("auth_session_expired", Res.string.auth_session_expired)
  map.put("auth_title_code", Res.string.auth_title_code)
  map.put("auth_title_email", Res.string.auth_title_email)
  map.put("auth_title_username", Res.string.auth_title_username)
  map.put("auth_username_intro", Res.string.auth_username_intro)
  map.put("auth_username_label", Res.string.auth_username_label)
  map.put("auth_username_placeholder", Res.string.auth_username_placeholder)
  map.put("auth_validate_code", Res.string.auth_validate_code)
}
